import { URLS } from 'services/urls';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { SocialSignUpConnection } from '../constants';

export interface IProps {
    handleSocialSignUp: (connection: SocialSignUpConnection) => void;
    enabled: boolean;
}

const SocialSignUpButtons = ({
    handleSocialSignUp,
    enabled,
}: IProps) => (
    <div className="DirectSignUp__SocialIconButtons">
        <div className="DirectSignUp__SocialButton DirectSignUp__SocialButton--google">
            <NSButtonBase
                color="secondary"
                callback={() => handleSocialSignUp(SocialSignUpConnection.GOOGLE)}
                className="DirectSignUp__SocialButton--full-width heap-deal-signup-direct-social-login"
                innerContentClassName="DirectSignUp__SocialButton__Content"
                disabled={!enabled}
                dataTestId="googleButton"
            >
                <span className="DirectSignUp__SocialButton__Inner DirectSignUp__SocialButton__Inner--full-width">
                    <img
                        className="DirectSignUp__SocialButton__Icon"
                        src={URLS.IMAGE_CLOUDFRONT_URL('socials/google.png')}
                        alt="Google"
                    />
                    <span>Continue with Google</span>
                </span>
            </NSButtonBase>
        </div>
        <div className="DirectSignUp__SocialButton DirectSignUp__SocialButton--icon">
            <NSButtonBase
                color="secondary"
                callback={() => handleSocialSignUp(SocialSignUpConnection.LINKEDIN)}
                className="heap-deal-signup-direct-social-login"
                innerContentClassName="DirectSignUp__SocialButton__Content"
                disabled={!enabled}
                dataTestId="linkedInButton"
            >
                <span className="DirectSignUp__SocialButton__Inner">
                    <img
                        className="DirectSignUp__SocialButton__Icon"
                        src={URLS.IMAGE_CLOUDFRONT_URL('socials/linkedin.png')}
                        alt="LinkedIn"
                    />
                </span>
            </NSButtonBase>
        </div>

        <div className="DirectSignUp__SocialButton DirectSignUp__SocialButton--icon">
            <NSButtonBase
                color="secondary"
                callback={() => handleSocialSignUp(SocialSignUpConnection.MICROSOFT)}
                className="heap-deal-signup-direct-social-login"
                innerContentClassName="DirectSignUp__SocialButton__Content"
                disabled={!enabled}
                dataTestId="microsoftButton"
            >
                <span className="DirectSignUp__SocialButton__Inner">
                    <img
                        className="DirectSignUp__SocialButton__Icon"
                        src={URLS.IMAGE_CLOUDFRONT_URL('socials/microsoft.png')}
                        alt="Microsoft"
                    />
                </span>
            </NSButtonBase>
        </div>
    </div>
);

export default SocialSignUpButtons;
